// One row of the "Dane z kart kierowców i wykresówek" grid
// (server: DriverChartDetailsDto). Analog charts + digital tachograph, merged.

// Mirrors server DriverDayType enum.
export enum DayType {
  None = 0,
  P = 1, // Praca (work)
  W = 2, // Wolne (off)
}

// Mirrors server TachographType enum.
export enum TachographType {
  Analog = 0,
  Digital = 1, // "Cyfrowe"
}

// Mirrors server TachographStatus enum (0 = NotSet / "Brak").
export enum TachographStatus {
  NotSet = 0,
  AETR = 1,
  NoActivity = 2,
  NoRecords = 3,
  ToFix = 4,
  ToClarify = 5,
}

export type DriverChartDetailsRow = {
  tachographChartId: number // 0 for digital rows
  driverId: number 
  driverFullName: string
  chartDate: string // Dzień (ISO)

  dayStartDate: string | null // Początek (UTC ISO)
  dayEndDate: string | null // Koniec (UTC ISO)

  vehicle: string // Pojazd (registration)
  dayType: DayType // Typ dnia
  isCrew: boolean // Załoga
  tachographType: TachographType // Dane (Analog / Cyfrowe)

  vehicleOdometerBegin: number // Licznik - start
  vehicleOdometerEnd: number // Licznik - koniec
  vehicleDistance: number // end - begin
  distanceFromTachographChart: number // Przebieg (z wykresu)

  isClosed: boolean | null // Zamknięta
  tachographStatus: TachographStatus // Status

  createdDate: string | null // Data utworzenia
  modifiedDate: string | null // Data modyfikacji
}
